/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBanPopoverContainer_story = {
    readonly id: string;
    readonly " $refType": "UserBanPopoverContainer_story";
};
export type UserBanPopoverContainer_story$data = UserBanPopoverContainer_story;
export type UserBanPopoverContainer_story$key = {
    readonly " $data"?: UserBanPopoverContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBanPopoverContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'f5a7e7fdbbbd70472bb5b6f3c7c457b8';
export default node;
